<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" >
				<el-form-item>
					<el-input v-model="filters.mac_id" placeholder="设备物理地址"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.phoneNumber" placeholder="用户手机号"></el-input>
				</el-form-item>
				<el-form-item v-if='GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan' label-width="120px">
					<el-input v-model="filters.upper_sysno"  placeholder="机构编号"></el-input>
				</el-form-item>
				<el-form-item>
					 <el-date-picker v-model="filters.time"  type="daterange"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="search">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table @sort-change='sortion' :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<!--<el-table-column type="selection" width="55">
			</el-table-column>-->
			<el-table-column type="index" width="40">
			</el-table-column>
			<el-table-column prop="mac_id" label="设备物理地址"  >
			</el-table-column>
			<!--<el-table-column prop="city" label="城市"  sortable></el-table-column>
			<el-table-column prop="address" label="地址"  sortable></el-table-column>-->
			<el-table-column prop="user_name" label="连接用户"  >
			</el-table-column>
			<el-table-column prop="phone_number" label="手机号码"  >
			</el-table-column>
			<el-table-column prop="cord_time" label="连接时间"  sortable='custom'></el-table-column>
			<el-table-column v-if='GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan' prop="upper_sysno" label="机构编号"  ></el-table-column>
			<!--<el-table-column label="操作" width="180">
				<template slot-scope="scope">
					<el-button size="small" @click="VerifyShow('handleEdit',scope.$index, scope.row)">修改</el-button>					
				</template>
			</el-table-column>-->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除{{addFormVisible}}</el-button>-->
			<el-pagination layout="prev, pager, next,jumper" :current-page='page'  @current-change="handleCurrentChange"  :page-size="size" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getDevice_link_cord} from '../api/api';

	export default {
		data() {
			return {
				filters: {
					mac_id:'',
					phoneNumber: '',
					upper_sysno:'',
					time:[]
				},
				users: [],
				total: 0,
				sort:'desc',
				prop:'cord_time',
				page: 1,
				size:10,
				listLoading: false,
				sels: [],//列表选中列
				index:'',
				row:'',
				
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.getCord();
			},
			search(){
				this.page=1
				this.getCord()
			},
			//排序
			sortion(row){
				this.prop=row.prop
				switch(row.order){
					case 'descending':
						this.sort='desc'
					break;
					case 'ascending':
						this.sort='asc'
					break;
				}
				this.getCord()
			},
			//获取用户列表
			getCord() {
				let upper_sysno=this.filters.upper_sysno
				if(!upper_sysno){
					upper_sysno=this.GLOBAL.organDetail.upper_sysno
				}
				let para = {
					mac_id:this.filters.mac_id,
					phoneNumber:this.filters.phoneNumber,
					upper_sysno:upper_sysno,
					time:this.filters.time?this.filters.time:[],
					prop:this.prop,
					sort:this.sort,
					pageNo:this.page,
					pageSize:this.size,
				};
				this.listLoading = true;
				getDevice_link_cord(para).then((res) => {
					console.log(res)
					this.total = res.data.data.rowcount;
					this.users = res.data.data.list;
					this.listLoading = false;
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
		},
		mounted() {
			this.getCord();
		}
	}

</script>

<style lang="scss" slot-scope>
	#phoneVerify .el-dialog__body .el-select{
		margin: 20px;
	}
	#phoneVerify .el-dialog__body>.el-input{
		width: 20%;
		margin: 20px;
	}
	#phoneVerify .el-button{
		width: 112px;
	}
</style>


// WEBPACK FOOTER //
// src/components/device_link_cord.vue